<template>
  <v-container fluid>
    <div v-if="loading_maps" class="d-flex justify-center">
      <v-progress-circular indeterminate />
    </div>
    <div v-else>
      <div class="d-flex">
        <v-spacer />
        <v-btn
          @click="creating = true"
          outlined
          small
        >
          <v-icon>mdi-plus</v-icon>
          Add map base
        </v-btn>
      </div>
      <v-select
        style="max-width: 400px;"
        :items="leagues.filter(league => !league.archived)"
        :loading="loading_leagues"
        item-value="id"
        item-text="league_name"
        placeholder="Liiga"
        clearable
        v-model="league"
      />
      <v-row style="align-items: center;">
        <v-col
          cols="3"
          v-for="map in filtered_maps"
          :key="map.id"
        >
          <MapCard
            :map="map"
          />
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="creating" max-width="800">
      <CreateMapBase
        @close="creating = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex/dist/vuex.common.js';
import MapCard from '@/components/tiimi_admin/maps/MapCard.vue'
import CreateMapBase from '@/components/tiimi_admin/league/map/CreateMapBase.vue';

export default {
  components: { MapCard, CreateMapBase },
  created() {
    this.initAdminMaps()
    this.initLeagues()
  },
  data: () => ({
    league: null,
    creating: false
  }),
  computed: {
    ...mapGetters('admin', [
      'loading_maps',
      'maps',
      'leagues',
      'loading_leagues'
    ]),
    filtered_maps() {
      if(!this.league) return this.maps
      return this.maps.filter(map => map.leagues.includes(this.league))
    }
  },
  methods: {
    ...mapActions('admin', [
      'initAdminMaps',
      'initLeagues'
    ])
  }
}
</script>